import { createFileRoute } from "@tanstack/react-router";
import type { JSX } from "react";
import SuperviseWorkinghoursPanel from "@/components/supervise/supervise-workinghours-panel";

const SuperviseRulebreaksPage = (): JSX.Element => <SuperviseWorkinghoursPanel rulebreaksOnly />;

export const Route = createFileRoute("/_app/supervise/rulebreaks/")({
	component: SuperviseRulebreaksPage,
});
